export const cn = {
    'common': {
        'warn': '温馨提示',
        'success': '成功',
        'ok': '确定',
        'cancle': '取消',
        'modify': '修改',
        'delete': '删除',
        'error': '错误信息',
        'loading': '正在加载中...',
        'your-position': '您的位置：',
        'home-page': '首页',
        'search': '搜索',
        'clear': '清空',
        'fold': '折叠',
        'search-advanced': '高级搜索',
        'export-excel': '导出Excel',
        'print-pdf': '打印',
        'unfold': '展开',
        'fold-all': '全部收起',
        'unfold-all': '全部展开',
        'collapse': '收起',
        'authentication-error': '权限错误',
        'request-error': '请求出错',
        'start-date': '开始日期',
        'end-date': '结束日期',
        'sort': '排序',
        'asc': '升序',
        'desc': '降序',
        'no-data': '没有符合条件的数据',
        'unknown-error': '未知错误',
        'setup-column': '配置列表',
        'setup-save': '保存配置',
        'setup-width': '列宽',
        'purchase-type': '订单性质',
        'purchase-date': '订单日期',
        'unfold-detail': '展开明细',
        'fold-detail': '隐藏明细',
        'download': '下载',
        'submit': '提交',
        'back': '返回',
        'extension': '扩展字段',
        'operate': '操作',
        'edit': '编辑',
        'please-select': '请选择',
        'none-data': '暂无数据',
        'print': '打印',
        'all': '全部',
        'save': '保存',
        '备注': '备注',
        'inquiry-publicly': '询价公开',
        'supplier-registration': '供应商注册',
        'contact-us': '联系我们',
        'name-tip': '请输入用户名!',
        'no-name': '用户名不存在!',
        'email-tip': '请输入邮箱!',
        'email-error': '邮箱格式不合法!',
        'account-login': '账户登录',
        'forget-password': '忘记密码',
        'enter-account': '请输入账户',
        'enter-password': '请输入密码',
        'password-length': '密码长度应为1-16位',
        'password-old': '新密码与旧密码没有变化',
        'password-again': '请再次输入密码',
        'password-different': '两次输入的密码不一致',
        'account': '账号',
        'code': '验证码',
        'enter-code': '请输入验证码',
        'code-tip': '验证码为6位数字',
        'enter-pwd': '请输入新密码',
        'pwd-tip': '密码长度应为1-16位',
        'pwd-again': '请再次输入新密码',
        'pwd-different': '两次输入的密码不一致'


    },
    'user': {
        'user-center': '个人中心',
        'modify-password': '修改密码',
        'modify-info': '修改资料',
        'modify-password-success': '修改密码成功',
        'modify-info-success': '修改用户信息成功',
        'email-wrong-format': '邮箱格式不正确！',
        'phone-wrong-format': '电话格式不正确！',
        'mobile-wrong-format': '手机格式不正确！',
        'userInfo': '用户信息',
        'no': '工号',
        'noInfo': '工号是必填信息',
        'nameRequired': '姓名是必填信息',
        'emailRequired': '邮箱是必填信息',
        'name': '姓名',
        'loginName': '登录名',
        'loginNameInfo1': '该用户名已被注册！',
        'loginNameInfo2': '登录名是必填信息！',
        'loginNameInfo3': '登录名只能是字母数字下划线！',
        'loginNameInfo4': '登录名最少四位！',
        'loginNameInfo5': '最大长度不能超过50位！',
        'newPassword': '密码',
        'passwordInfo': '若不修改请留白',
        'newPasswordInfo1': '密码不能为空!',
        'newPasswordInfo2': '密码长度不得少于三位！',
        'confirmNewPassword': '确认密码',
        'confirmNewPasswordInfo': '两次密码输入不一致！',
        'ent': '默认企业编码',
        'entInfo': '企业编码不能为空!',
        'loginFlag': '是否允许登录',
        'loginFlag1': '允许',
        'loginFlag2': '不允许',
        'userAuthority': '用户权限',
        'userRole': '用户角色',
        'userRoleInfo': '如果修改自己的角色，修改成功后需要重新登录',
        'nzTitle': '非必填(点击展开)',
        'email': '邮箱',
        'phone': '电话',
        'mobile': '手机',
        'site': '据点',
        'defaultSite': '默认据点',
        'employeeNo': 'erp用户编号',
        'employeeName': 'erp员工姓名',
        'departmentNo': '部门编码',
        'departmentName': 'erp部门名称',
        'ware': '默认仓库',
        'remarks': '备注',
        'userList': '用户列表',
        'userAdd': '新增用户',
        'userAdded': '用户已添加',
        'userEdit': '用户编辑',
        'editSuccess': '修改成功',
        'name-placeholder': '真实名称',
        'loginName-placeholder': '登录名称',
        'companyName': '供应商名称',
        'officeName': '部门名称',
        'mobile-placeholder': '手机号码',
        'operate': '操作',
        'edit': '编辑',
        'delete': '删除',
        'warnInfo1': '确认删除该用户？',
        'current-account-no': '您当前的账号',
        'modifier': '修 改',
        'login-password': '登录密码',
        'login-password-tip': '为保护账户安全，建议您定期更改密码',
        'personal-data': '个人资料',
        'update-timely': '如果您的个人资料有变化，请及时更新',
        'old-password': '旧密码',
        'new-password': '新密码',
        'confirm-new-password': '确认新密码',
        'user-tip': '用户默认集团有误，请重新选择'


    },
    'shared': {
        'all': '全部',
        'loading': '正在加载中',
        'yes': '是',
        'no': '否',
        'page-total-count': '共{{totalNum}}条，',
        'page-total-pages': '共{{totalPage}}页，',
        'page-goto': '到',
        'page': '页',
        'page-previous': '上一页',
        'page-first': '首页',
        'page-next': '下一页',
        'page-last': '末页',
        'page-each': '每页',
        'page-each-count': '条，',
        'table-colName': '配置字段',
        'table-sort': '显示顺序',
        'table-width': '显示列宽',
        'table-orderField': '查询排序',
        'table-orderType': '升降序',
        'table-not-surported': '暂不支持排序'
    },
    'home': {
        'common': {
            'anounce-list': '公告列表',
            'anounce-detail': '公告详情',
            'message-list': '消息列表',
            'welcome': '欢迎来到云供应商平台',
            'supplier': '云供应商',
            'ent': '集团：',
            'title-home': '首页',
            'title-login': '登录',
            'title-register': '注册',
            'title-anounce': '公告',
            'title-anounce-detail': '全文',
            'title-message': '我的消息',
            'find-psd': '找回密码',
            'today-order': '今日订单',
            'unconfirmed-order': '未确认订单',
            'overdue-order': '逾期未出货订单',
            'order-transit': '送货在途订单',
            'get-code': '获取验证码',
            'confirm-modification': '确认修改'
        },
        'login': {
            'select-language': '选择语言',
            'please-fill-userid': '请填写账号',
            'please-fill-password': '请填写密码',
            'user-placeholder': '用户名',
            'password-placeholder': '密码',
            'login': '登录',
            'login-now': '立即登录',
            'logout': '登出',
            'platform': '云交货协同平台',
            'zhilink-home': '智互联官网',
            'zhilink-copyright': '技术支持:©{{year}} 智互联（深圳）科技有限公司',
            'owner-website': '官方网站',
            'owner-copyright': '©CopyRight {{year}}',
            'owner-copyright2': '版权所有',
            'owner-phone': '联系电话:',
            'owner-mail': '联系邮箱:'
        },
        'register': {
            'form-title': '供应商注册信息',
            'success': '信息提交成功，请等待审核，近期请注意留意邮箱！'
        },
        'notfound': {
            'not-found-page': '出错啦，您访问的页面没有找到！',
            'redirect-after-seconds': '{{count}}秒后自动跳转...',
            'redirect-imediately': '立即跳转'
        },
        'anounce': {
            'title': '标题',
            'date': '日期',
            'more': '查看更多',
            'no-more-data': '没有更多公告了'
        },
        'message': {
            'title': '标题',
            'please-select-category': '请选择消息分类：',
            'all': '全部',
            'read': '已读',
            'unread': '未读',
            'mark-as-read': '全部标为已读'
        }
    },
    'other': {
        '温馨提示': '温馨提示',
        '收货仓库': '收货仓库',
        '仓库储位': '仓库储位',
        '已结案订单明细': '已结案订单明细',
        '有答交日期在今天之前，': '有答交日期在今天之前，',
        '交总数量小于产品数量，': '交总数量小于产品数量，',
        '您确定要保存吗？': '您确定要保存吗？'
    }
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/i18n/zh-CN.ts